export default function getIntercomUserData(
  userData,
  accessLevel,
  paymentDetails
) {
  if (!userData) {
    return {};
  }

  return {
    email: userData.email,
    userId: String(userData.id),
    name: userData.username,
    first_name: userData.first_name,
    email_validated: userData.email_validated,
    plan_name: paymentDetails?.plan_name || "",
    personal_data_processing: userData.personal_data_processing,
    electronic_communication: userData.electronic_communication,
    marketing_emails: userData.marketing_emails,
    customAttributes: {
      first_name: userData.first_name,
      email_validated: userData.email_validated,
      plan_name: paymentDetails?.plan_name || "",
      personal_data_processing: userData.personal_data_processing,
      electronic_communication: userData.electronic_communication,
      marketing_emails: userData.marketing_emails
    },
    user_hash: userData.intercom_user_hash
  };
}
